import { render, staticRenderFns } from "./dimensionUploadComplete.vue?vue&type=template&id=3d80ae59&"
import script from "./dimensionUploadComplete.vue?vue&type=script&lang=js&"
export * from "./dimensionUploadComplete.vue?vue&type=script&lang=js&"
import style0 from "./dimensionUploadComplete.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports